import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  button: { "&.MuiSvgIcon-root": {fontSize: '45px'} },
})

export default useStyles
